import Cookies from "js-cookie";

export const clearCookies = () => {
	Cookies.remove("XSRF-TOKEN");
	Cookies.remove("ownerya_session");
};
